import React, {useRef, useEffect } from 'react'
// import logo from './logo.svg';
import './App.sass';

import AnimatedCursor from "react-animated-cursor"
import Nav from './assets/components/Nav'
import Hero from './assets/components/Hero'
import About from './assets/components/About'
import Portfolio from './assets/components/Portfolio'
import PortfolioData from './assets/data/PortfolioData';

import Skill from './assets/components/Skill';
import SkillData from './assets/data/SkillData';

import Cta from './assets/components/Cta'


function App() {
  
  return (
    <div className="main-wrapper">
      <AnimatedCursor
        innerSize={8}
        outerSize={8}
        color='154, 165, 182'
        outerAlpha={0.2}
        innerScale={0.7}
        outerScale={5}
      />
      <Nav />
      <Hero />
      <About />
      <Portfolio PortfolioData={PortfolioData} />
      <Skill SkillData={SkillData} />
      <Cta />
    </div>
  );
}

export default App;
